jQuery(function ($) {
  if (jQuery("#maptable").length > 0) {
    var infobox = document.getElementById("maptable");
    var maat = infobox.getElementsByTagName("div");
    for (var i = 0; i < maat.length; i++) {
      if (maat[i].id.search("maainfo_") != -1 && maat[i].id != "maainfo_FI") {
        maat[i].style.display = "none";
      }
    }
    if (window.location.hash != "") {
      var hash = window.location.hash;
      try {
        jQuery(hash).trigger("click");
      } catch (e) {}
    }
  }
});
function vaihda_maa(maa, kuva) {
  document
    .getElementById("karttakuva")
    .setAttribute("xlink:href", "/wp-content/themes/tasowheel/images/" + kuva);
  try {
    document
      .getElementById("karttakuva")
      .setAttribute("src", "/wp-content/themes/tasowheel/images/" + kuva);
  } catch (e) {}
  var infobox = document.getElementById("maptable");
  var maat = infobox.getElementsByTagName("div");
  for (var i = 0; i < maat.length; i++) {
    if (maat[i].id.search("maainfo_") != -1) {
      if (maat[i].id != "maainfo_" + maa) {
        maat[i].style.display = "none";
      } else {
        maat[i].style.display = "";
      }
    }
  }
}
